import React from "react";

/* Download — an invoice or receipt coming down. */
export const DownloadIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <path d="M12 3v12M7.5 10.5L12 15l4.5-4.5"
          stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2"
          stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export default DownloadIcon;
